import { render, staticRenderFns } from "./sickinformation.vue?vue&type=template&id=866b72d8&scoped=true&"
import script from "./sickinformation.vue?vue&type=script&lang=js&"
export * from "./sickinformation.vue?vue&type=script&lang=js&"
import style0 from "./sickinformation.vue?vue&type=style&index=0&id=866b72d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866b72d8",
  null
  
)

export default component.exports